export const borderRadius = {
  20: '1.25rem',
  round: '50%',
};
